import * as React from 'react';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MuiDrawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Autocomplete from '@mui/material/Autocomplete';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Badge from '@mui/material/Badge';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Link from '@mui/material/Link';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useRef ,useState} from 'react';
import Grid from '@mui/material/Grid';
import { createSearchParams, useLocation } from "react-router-dom";
import { store } from '../helpers/store';
import { setPageLoadFinish, setPageLoading } from '../slices/page.slice';
import { fetchOrders, orderItemsSelector, setOrderLoading, setOrderSearchKeyDeliverylocationumber, setOrderSearchKeyFromdate, setOrderSearchKeySaletype, setOrderSearchKeyTodate, setOrderSearchKeyNumber, setOrderSearchKey, clearOrderFilters, fetchOrder, setSelectedOrderId, setOrderCYLLSearchKey, setOrderCYLRSearchKey, setOrderSPHLSearchKey, setOrderSPHRSearchKey, setOrderLensTitleSearchKey, setOrderLensTypeSearchKey, setOrderStoreNameSearchKey, setOrderADDLSearchKey, setOrderADDRSearchKey, setOrderFinalUserSearchSearchKey, setOrderStateSearchKey, setOrderFinalCreatorSearchSearchKey, setOrderConsumerSearchKey, setOrderCoatingSearchKey, setOrderLoadingFalse, setOrderDescriptionSearchKey } from "../slices/orders.slice";
import DataGrid from 'react-data-grid';
import CircularProgress from '@mui/material/CircularProgress';
import LinearProgress from '@mui/material/LinearProgress';
import Checkbox from '@mui/material/Checkbox';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { pink } from '@mui/material/colors';
import SvgIcon from '@mui/material/SvgIcon';
import DehazeIcon from '@mui/icons-material/Dehaze';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import IconButton from '@mui/material/IconButton';
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import TextField from '@mui/material/TextField';
import DatePicker from "react-multi-date-picker"
import { Calendar } from "react-multi-date-picker"
import moment from 'jalali-moment'
import Tooltip from '@mui/material/Tooltip';
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import JalaliUtils from "@date-io/jalaali";
import SearchIcon from '@mui/icons-material/Search';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import Modal from "@material-ui/core/Modal";
import { useNavigate } from "react-router-dom";
import { fetchRXOrder, setRXOrderConsumer, setRXPreviewItemsDialogOpen } from '../slices/rxorder.slice';
import { fetchSTOrder, getSTOrderPreview } from '../slices/storder.slice';
import RXPreviewItems from './RXPreviewItems';
import STPreviewItems from './STPreviewItems';
import { getRXOrderPreview } from '../slices/rxorder.slice';


export const zeroPad = (num, places) => String(num).padStart(places, '0');




export const Orders = (props) => {

  const dispatch = useDispatch();
  //const { user: authUser } = useSelector(x => x.auth);
  const authUser = JSON.parse(localStorage.getItem('user'));

  const orders = useSelector(x => x.orders);
  const defaultValues1 = useSelector(x => x.defaultValue);
  const defaultValues = JSON.parse(localStorage.getItem('defaultValue'));
  const rxOrder = useSelector(x => x.rxOrder);
  const stOrder = useSelector(x => x.stOrder);

  let navigate = useNavigate();


const columns = [
  {
    key: "ID",
    name: '',
   
    resizable: false,
    sortable: false,
    frozen: false,
    headerRenderer(props) {
      return ( ""
       
      );
    },
    formatter(props) {
      return  <Checkbox  onChange={(e) => handleChange(e,'unitTitle', props,props.row.UnitTitle)}/>;
    },
    groupFormatter(props) {
      return  <Checkbox/>;
    },
    width: '2%'
  },
  {
    name: 'ردیف',
    key: 'rowIndex',
    width: '1%',
  }, 
  {
    key: 'Number',
    name: 'شماره',
    width: '10%',
    resizable: true,
    sortable: false,
    formatter(props) {
      //console.log(props.row);
      return <Link component="button"variant="body2" onClick={(e) => handleChange(e,'number', props, props.row.OrderId)}>{props.row.Number}#</Link>
    },
    headerRenderer(props) {
      return (
      <span>
        شماره
        <hr/>
        <TextField fullWidth value={orders.searchKey} size="small" variant="outlined" onKeyDown={onSearchHandler} onChange={onSearchChange} />
        </span>
      );
    },
  },
  //{
  //  key: 'CustomerTitle',
  //  name: 'عنوان مشتری',
  //  width: '15%',
  //  resizable: true,
  //  sortable: false
  //},
  //{
  //  key: 'CustomerCode',
  //  name: 'کد مشتری',
  //  width: '10%',
  //  resizable: true,
  //  sortable: false
  //},
  {
    key: 'OrderType',
    name: 'نوع سفارش',
    width: '10%',
    resizable: true,
    sortable: false
  },
  {
    key: 'TrackingCode',
    name: 'کد رهگیری',
    width: '10%',
    resizable: true,
    sortable: false
  },
  {
    key: 'FinalUser',
    name: 'مشتری',
    width: '10%',
    resizable: true,
    sortable: false,
    headerRenderer(props) {
      console.log(props)
      return (
      <span>
        مشتری
        <hr/>
        <Autocomplete
                              options={authUser.underControlUsers.map(x => ({ id: x.Value, label: x.Code}))}
                              //getOptionLabel={option => option}
                              renderOption={(props, option, state) => 
                                <div {...props} style={{ textAlign : "left" , direction : "ltr" }}>
                                  {option.label}
                                </div>
                              }
                              filterSelectedOptions
                              renderInput={params => (
                                <TextField
                                  {...params}
                                  fullWidth
                                  variant="outlined"
                                  placeholder=""
                                  sx={{
                                    
                                    '.MuiInputBase-input': { fontSize: '13px' },
                                  }}
                                />
                              )}
                              onSelect={onSearchHandler}
                              onChange={onSearchFinalUserChange}
                              value={orders.searchKey_finalUserSearch !== undefined && orders.searchKey_finalUserSearch !== null && orders.searchKey_finalUserSearch !== "" ? authUser.underControlUsers.find(r => r.Value == orders.searchKey_finalUserSearch).Code : ''}
                              size="small"
                              noOptionsText={<span className='noDataText'>اطلاعاتی یافت نشد</span>}
                              //disabled={(rxOrder.LSPH === null)}
                            />
        </span>
      );
    },
    formatter(props) {
      return <span>{defaultValues !== null && props.row.FinalUser !== null && props.row.FinalUser !== undefined && props.row.FinalUser !== "" && defaultValues.PortalUsers !== null && defaultValues.PortalUsers !== undefined && defaultValues.PortalUsers.find(r => r.ID == props.row.FinalUser) ? defaultValues.PortalUsers.find(r => r.ID == props.row.FinalUser).UserName : ""}</span>
    }
  },
  {
    key: 'FinalCreator',
    name: 'ثبت کننده',
    width: '10%',
    resizable: true,
    sortable: false,
    headerRenderer(props) {
      console.log(props)
      return (
      <span>
        ثبت کننده
        <hr/>
        <Autocomplete
                              options={authUser.underControlUsers.map(x => ({ id: x.Value, label: x.Code}))}
                              //getOptionLabel={option => option}
                              renderOption={(props, option, state) => 
                                <div {...props} style={{ textAlign : "left" , direction : "ltr" }}>
                                  {option.label}
                                </div>
                              }
                              filterSelectedOptions
                              renderInput={params => (
                                <TextField
                                  {...params}
                                  fullWidth
                                  variant="outlined"
                                  placeholder=""
                                  sx={{
                                    
                                    '.MuiInputBase-input': { fontSize: '13px' },
                                  }}
                                />
                              )}
                              onSelect={onSearchHandler}
                              onChange={onSearchFinalCreatorChange}
                              value={orders.searchKey_finalCreatorSearch !== undefined && orders.searchKey_finalCreatorSearch !== null && orders.searchKey_finalCreatorSearch !== "" ? authUser.underControlUsers.find(r => r.Value == orders.searchKey_finalCreatorSearch).Code : ''}
                              size="small"
                              noOptionsText={<span className='noDataText'>اطلاعاتی یافت نشد</span>}
                              //disabled={(rxOrder.LSPH === null)}
                            />
        </span>
      );
    },
    formatter(props) {
      return <span>{defaultValues !== null && props.row.FinalCreator !== null && props.row.FinalCreator !== undefined && props.row.FinalCreator !== "" && defaultValues.PortalUsers !== null && defaultValues.PortalUsers !== undefined && defaultValues.PortalUsers.find(r => r.ID == props.row.FinalCreator) ? defaultValues.PortalUsers.find(r => r.ID == props.row.FinalCreator).UserName : ""}</span>
    }
  },
  {
    key: 'State',
    name: 'وضعیت',
    width: '10%',
    resizable: true,
    sortable: false,
    headerRenderer(props) {
      return (
      <span>
        وضعیت
        <hr/>
        <TextField fullWidth value={orders.searchKey_state} size="small" variant="outlined" onKeyDown={onSearchHandler} onChange={onSearchStateChange} />
        </span>
      );
    },
  },
  {
    key: 'Date',
    name: 'تاریخ',
    width: '10%',
    resizable: true,
    sortable: false,
  },
  {
    key: 'LensType',
    name: 'نوع لنز',
    width: '10%',
    resizable: true,
    sortable: false,
    headerRenderer(props) {
      return (
      <span>
        نوع لنز
        <hr/>
        <TextField fullWidth value={orders.searchKey_lensType} size="small" variant="outlined" onKeyDown={onSearchHandler} onChange={onSearchLensTypeChange}/>
        </span>
      );
    },
  },
  {
    key: 'LensTitle',
    name: 'لنز',
    width: '20%',
    resizable: true,
    sortable: false,
    headerRenderer(props) {
      return (
      <span>
        لنز
        <hr/>
        <TextField fullWidth  value={orders.searchKey_lensTitle} size="small" variant="outlined" onKeyDown={onSearchHandler} onChange={onSearchLensTitleChange}   />
        </span>
      );
    },
  },
  {
    key: 'SPHR',
    name: 'SPHR',
    width: '5%',
    resizable: true,
    sortable: false,
    headerRenderer(props) {
      return (
      <span>
        SPHR
        <hr/>
        <TextField fullWidth value={orders.searchKey_sphr} size="small" variant="outlined" onKeyDown={onSearchHandler} onChange={onSearchSPHRChange}   />
        </span>
      );
    },
  },
  {
    key: 'CYLR',
    name: 'CYLR',
    width: '5%',
    resizable: true,
    sortable: false,
    headerRenderer(props) {
      return (
      <span>
        CYLR
        <hr/>
        <TextField fullWidth value={orders.searchKey_cylr} size="small" variant="outlined" onKeyDown={onSearchHandler} onChange={onSearchCYLRChange}   />
        </span>
      );
    },
  },
  {
    key: 'ADDR',
    name: 'ADDR',
    width: '5%',
    resizable: true,
    sortable: false,
    headerRenderer(props) {
      return (
      <span>
       ADDR
        <hr/>
        <TextField fullWidth value={orders.searchKey_addr} size="small" variant="outlined" onKeyDown={onSearchHandler} onChange={onSearchADDRChange}   />
        </span>
      );
    },
  },
  {
    key: 'SPHL',
    name: 'SPHL',
    width: '5%',
    resizable: true,
    sortable: false,
    headerRenderer(props) {
      return (
      <span>
        SPHL
        <hr/>
        <TextField fullWidth value={orders.searchKey_sphl} size="small" variant="outlined" onKeyDown={onSearchHandler} onChange={onSearchSPHLChange}   />
        </span>
      );
    },
  },
  {
    key: 'CYLL',
    name: 'CYLL',
    width: '5%',
    resizable: true,
    sortable: false,
    headerRenderer(props) {
      return (
      <span>
        CYLL
        <hr/>
        <TextField fullWidth value={orders.searchKey_cyll} size="small" variant="outlined" onKeyDown={onSearchHandler} onChange={onSearchCYLLChange}   />
        </span>
      );
    },
  },
  {
    key: 'ADDL',
    name: 'ADDL',
    width: '5%',
    resizable: true,
    sortable: false,
    headerRenderer(props) {
      return (
      <span>
        ADDL
        <hr/>
        <TextField fullWidth value={orders.searchKey_addl} size="small" variant="outlined" onKeyDown={onSearchHandler} onChange={onSearchADDLChange}   />
        </span>
      );
    },
  },
  {
    key: 'Coating',
    name: 'پوشش',
    width: '10%',
    resizable: true,
    sortable: false,
    headerRenderer(props) {
      return (
      <span>
        پوشش
        <hr/>
        <TextField fullWidth value={orders.searchKey_coating} size="small" variant="outlined" onKeyDown={onSearchHandler} onChange={onSearchCoatingChange} />
        </span>
      );
    },
  },
  {
    key: 'Consumer',
    name: 'مصرف کننده',
    width: '10%',
    resizable: true,
    sortable: false,
    headerRenderer(props) {
      return (
      <span>
        مصرف کننده
        <hr/>
        <TextField fullWidth value={orders.searchKey_consumer} size="small" variant="outlined" onKeyDown={onSearchHandler} onChange={onSearchConsumerChange} />
        </span>
      );
    },
  },
  {
    key: 'StoreName',
    name: 'فروشگاه',
    width: '10%',
    resizable: true,
    sortable: false,
    headerRenderer(props) {
      return (
      <span>
       فروشگاه
        <hr/>
        <TextField fullWidth value={orders.searchKey_storeName} size="small" variant="outlined" onKeyDown={onSearchHandler} onChange={onSearchStoreNameChange}/>
        </span>
      );
    },
  },
  {
    key: 'Description',
    name: 'توضیح',
    width: '20%',
    resizable: true,
    sortable: false,
    headerRenderer(props) {
      return (
      <span>
       توضیح
        <hr/>
        <TextField fullWidth value={orders.searchKey_description} size="small" variant="outlined" onKeyDown={onSearchHandler} onChange={onSearchDescriptionChange}/>
        </span>
      );
    },
  }
  
];


   useEffect(() => {
      console.log(props);
      //dispatch(setLoading());
      if(orders.fetchPermission){
        if(!orders.loading){
          dispatch(fetchOrders({hasMore: true, pageindex: 0 , justPreStates : props.theData.justPreStates , searchKey : orders.searchKey, fromdate: (orders.searchKey_fromdate !== '' ? orders.searchKey_fromdate : null), todate : (orders.searchKey_todate !== '' ? orders.searchKey_todate : null ), authUser}));
        }
      }

   }, []);


   const handleChange = (e , changingItemType, props , value) => {
  
    switch(changingItemType) {
      case 'unitTitle':
        // code block
        //console.log(props.row.Number);
        break;
      case 'number':
        console.log("Value is "+ value);
        if(!orders.loading){
          if(props.row.OrderType === "ST"){
            //navigate('/ST');
            dispatch(setOrderLoading());
            dispatch(fetchSTOrder({ orderId : value , authUser, isDetails : 1}));
            //dispatch(setOrderLoadingFalse());
            //dispatch(getSTOrderPreview({ stOrder : stOrder , authUser}));
            
          }
          else 
          {
            //navigate('/RX');
            dispatch(setOrderLoading());
            dispatch(fetchRXOrder({ orderId : value , authUser , isDetails : 1}));
            //dispatch(setOrderLoadingFalse());
            //dispatch(getRXOrderPreview({ rxOrder : rxOrder , authUser}));
          }
        }
        //dispatch(setSelectedOrderId(value));

        //این اوکیه
        //navigate({ pathname : '/order' , search : createSearchParams({
        //    entityId : value
        //}).toString()});
      
       
       
        break;
      default:
        // code block
    }
  
  }
  
  function rowKeyGetter(row) {
    return row.OrderId;
  }

  
   async function handleScroll(event) {
    if (orders.loading || !isAtBottom(event)) return;


    await loadMoreRows();

    //setRows([...rows, ...newRows]);
    //setIsLoading(false);
  }
  function EmptyRowsRenderer() {
    return (
    
      <div style={{ textAlign: 'center', gridColumn: '1/-1' }}>
        {orders.loading ? '' :   ' اطلاعاتی برای نمایش وجود ندارد' }
      </div>
    );
  }
  function isAtBottom({ currentTarget }) {
    if(currentTarget.scrollTop + 10 >= currentTarget.scrollHeight - currentTarget.clientHeight){
        //console.log("isAtBottom");
        
    }
    return currentTarget.scrollTop + 10 >= currentTarget.scrollHeight - currentTarget.clientHeight;
  }
  
  function loadMoreRows() {
    //console.log("currentPageIndex for load more"); 
    if(!orders.loading){
      dispatch(fetchOrders({hasMore: orders.hasMore, pageindex: orders.currentPageIndex , justPreStates : props.theData.justPreStates , searchKey_coating : orders.searchKey_coating, searchKey_state : orders.searchKey_state, searchKey_addl : orders.searchKey_addl, searchKey_addr : orders.searchKey_addr, searchKey_finalUserSearch : orders.searchKey_finalUserSearch, searchKey_storeName : orders.searchKey_storeName, searchKey_consumer : orders.searchKey_consumer, searchKey_cyll : orders.searchKey_cyll, searchKey_cylr : orders.searchKey_cylr, searchKey_sphl : orders.searchKey_sphl, searchKey_sphr : orders.searchKey_sphr, searchKey_description : orders.searchKey_description, searchKey_lensTitle : orders.searchKey_lensTitle, searchKey_lensType : orders.searchKey_lensType , searchKey : orders.searchKey, searchKey : orders.searchKey, fromdate: (orders.searchKey_fromdate !== '' ? orders.searchKey_fromdate : null ), todate : (orders.searchKey_todate !== '' ? orders.searchKey_todate : null), authUser}));
    }

    //dispatch(fetchOrders({hasMore: orders.hasMore, pageindex: orders.currentPageIndex , searchKey_cyll : orders.searchKey_cyll, searchKey_cylr : orders.searchKey_cylr, searchKey_sphl : orders.searchKey_sphl, searchKey_sphr : orders.searchKey_sphr, searchKey_lensTitle : orders.searchKey_lensTitle, searchKey_lensType : orders.searchKey_lensType, searchKey : orders.searchKey, fromdate: (orders.searchKey_fromdate === '' ? defaultValues.FiscalYearStartDate : orders.searchKey_fromdate), todate : (orders.searchKey_todate === '' ?defaultValues.FiscalYearEndDate : orders.searchKey_todate ), authUser}));
  }

  
   let dataSource  = [];

   if(orders.items !== undefined && orders.items.length > 0)
   {
       dataSource = orders.items.map((item, i) => ({...item, rowIndex : i+1}));
   }
   const dynamicHeight = orders.items.length === 0 ? '20vh' : Math.min(orders.items.length * 6 + 20, 75) + 'vh';

   const mdTheme = createTheme({
    typography: {
      fontFamily: [
        "mohammadfont",
        "Tahoma",
        "Verdana"
      ].join(",")
    },
    direction: 'rtl',
    components: {
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            backgroundColor: '#FBC02D',
            color: '#424242'
          },
        },
      },
    }
  });

const onSearchHandler = (e) =>{

  if(e.type === "click" || e.type === "onSelect" || (e.type === "keydown" && e.code === "Enter")){
    if(!orders.loading){
      dispatch(fetchOrders({hasMore: true, pageindex: 0 , justPreStates : props.theData.justPreStates , searchKey_coating : orders.searchKey_coating, searchKey_state : orders.searchKey_state, searchKey_addl : orders.searchKey_addl, searchKey_addr : orders.searchKey_addr, searchKey_finalUserSearch : orders.searchKey_finalUserSearch, searchKey_storeName : orders.searchKey_storeName, searchKey_consumer : orders.searchKey_consumer, searchKey_cyll : orders.searchKey_cyll, searchKey_cylr : orders.searchKey_cylr, searchKey_sphl : orders.searchKey_sphl, searchKey_sphr : orders.searchKey_sphr, searchKey_description : orders.searchKey_description, searchKey_lensTitle : orders.searchKey_lensTitle, searchKey_lensType : orders.searchKey_lensType , searchKey : orders.searchKey, searchKey : orders.searchKey, fromdate: (orders.searchKey_fromdate !== '' ? orders.searchKey_fromdate : null), todate : (orders.searchKey_todate !== '' ? orders.searchKey_todate : null ), authUser}));
    }
  }

}

const onClearFilterHandler = (e) =>{

  dispatch(clearOrderFilters());

}
const onSearchStateChange = (e) =>{

  dispatch(setOrderStateSearchKey(e.target.value));
}

const onSearchChange = (e) =>{

  dispatch(setOrderSearchKey(e.target.value));
}
const onSearchLensTypeChange = (e) =>{
  dispatch(setOrderLensTypeSearchKey(e.target.value));
}
const onSearchLensTitleChange = (e) =>{
  dispatch(setOrderLensTitleSearchKey(e.target.value));
}
const onSearchStoreNameChange = (e) =>{
  dispatch(setOrderStoreNameSearchKey(e.target.value));
}
const onSearchDescriptionChange = (e) =>{
  dispatch(setOrderDescriptionSearchKey(e.target.value));
}
const onSearchConsumerChange = (e) =>{
  dispatch(setOrderConsumerSearchKey(e.target.value));
}
const onSearchCoatingChange =(e) =>{
  dispatch(setOrderCoatingSearchKey(e.target.value));
}
const onSearchADDLChange = (e) =>{
  dispatch(setOrderADDLSearchKey(e.target.value));
}
const onSearchADDRChange = (e) =>{
  dispatch(setOrderADDRSearchKey(e.target.value));
}
const onSearchFinalUserChange = (e) =>{
  dispatch(setOrderFinalUserSearchSearchKey(e.target.value));
}
const onSearchFinalCreatorChange = (e) =>{
  dispatch(setOrderFinalCreatorSearchSearchKey(e.target.value));
}
const onSearchSPHRChange = (e) =>{
  dispatch(setOrderSPHRSearchKey(e.target.value));
}
const onSearchSPHLChange = (e) =>{
  dispatch(setOrderSPHLSearchKey(e.target.value));
}
const onSearchCYLRChange = (e) =>{
  dispatch(setOrderCYLRSearchKey(e.target.value));
}
const onSearchCYLLChange = (e) =>{
  dispatch(setOrderCYLLSearchKey(e.target.value));
}
const onFromDateSelectedHandler = (e) =>{
  var day = zeroPad(e.day , 2);
  var month = zeroPad(e.month.number , 2);
  var year = e.year;

  dispatch(setOrderSearchKeyFromdate(year + "/" + month + "/"+ day));
  
}
const onToDateSelectedHandler = (e) =>{
  var day = zeroPad(e.day , 2);
  var month = zeroPad(e.month.number , 2);
  var year = e.year;
  dispatch(setOrderSearchKeyTodate(year + "/" + month + "/"+ day));
}

  return (
    <>

<ThemeProvider theme={mdTheme}>

   <Box sx={{ flexGrow: 1 }}>
     
   <Grid container>
            <Grid item xs={12}>
                     
                      <Accordion>
              <AccordionSummary
                expandIcon={<FilterAltIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
               <Typography sx={{ width: '33%', flexShrink: 0 }}>
          {props.theData.pageTitle}
          </Typography>
          <Typography sx={{ color: 'text.secondary' }}>برای جستجو کلیک کنید</Typography>

              </AccordionSummary>
              <AccordionDetails>    
                <span className='fontSize14'>
                  از  تاریخ :
              </span>
                <DatePicker value={orders.searchKey_fromdate}
                            onChange={onFromDateSelectedHandler}
                            calendar={persian}
                            locale={persian_fa}
                            animation="true"
                            inputClass="dateCss" style = {{width: 150}}
                          />
                 <span className='fontSize14'>
تا تاریخ :              </span>
                <DatePicker value={orders.searchKey_todate}
                            onChange={onToDateSelectedHandler}
                            calendar={persian}
                            locale={persian_fa}
                            animation="true"
                            inputClass="dateCss" style = {{width: 150}}
                          />
                          <Tooltip arrow followCursor title="جستجو">
                          <IconButton onClick={onSearchHandler}>
                  <SearchIcon sx={{ color: '#2979FF' }}/>
                </IconButton>
              </Tooltip>
              <Tooltip arrow followCursor title="حذف فیلترها">
                                        <IconButton onClick={onClearFilterHandler}>
                                <FilterAltOffIcon sx={{ color: '#F44336' }}/>
                              </IconButton>
              </Tooltip>
              </AccordionDetails>
        </Accordion>
           </Grid>
   </Grid>
   </Box>
  <DataGrid 
    className='headerWithFilterGrid'
    renderers={{ noRowsFallback: <EmptyRowsRenderer /> }}
    direction="rtl" 
    columns={columns} 
    rows={dataSource} 
    rowKeyGetter={rowKeyGetter}
    onScroll={handleScroll}
    headerRowHeight={100}
    style={{height : dynamicHeight}}
    />

    

    {orders.loading ?   <div className="LoadingDiv">در حال تبادل اطلاعات <LinearProgress color="inherit" /></div>: "" }
    <RXPreviewItems />
    <STPreviewItems />
    </ThemeProvider>
    </>
  );
}

export default Orders;